export default __webpack_public_path__ + "static/media/watermark2.427c373e.png";